import type { I18nFn } from '#/i18n/types/I18nFn';
import type { SearchFacetData } from '#/modules/search/types/SearchFacetData';

export function doneInADayFacet(i18n: I18nFn) {
  return {
    id: 'canBeDoneInADayFacet',
    name: 'canBeDoneInADay',
    get title() {
      return i18n('Show only Done in a Day');
    },
    options: ['true', 'false'],
    optionTitles: {
      true: 'Yes',
      false: 'No',
    },
    type: 'boolean',
    sort: false,
  } as const satisfies SearchFacetData;
}
